<template>
  <v-card rounded class="notifications">
    <v-card-text>
        <v-list dense>
          <v-list-item v-for="warning, idx in warnings" :key="idx" :class="warning.type === 'warning' ? 'w-alert' : 'w-error'">
            <v-list-item-icon>
              <v-icon :color="color(warning)">{{ warning.type === 'warning' ? 'mdi-alert-box': 'mdi-alert-octagon' }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              {{warning.ts}} {{ warning.displayID}}: {{ warning.msg }}
            </v-list-item-content>
          </v-list-item>
        </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'warnings'
    ])
  },

  created() {
    if (this.$route.name === "Notifications") {
      // ! update title
      document.title = `Notifications`;
    }
  },

  methods: {
    color(w) {
      if (w.type === 'error') {
        return 'red';
      }
      return 'orange'
    }
  }
}
</script>

<style scoped>
.v-card {
  /*height: 28vh !important;*/
  /*max-height: 28vh;*/
  height: 100% !important;
  min-height: 200px;
  overflow-y: auto;
}

.w-alert {
  color:orange !important;
}

.w-error {
  color:red !important;
}

.v-list-item:nth-of-type(odd) {
  background-color: #252525;
}

.v-list-item {
  border-bottom: 1px solid whitesmoke;
  padding: 4px;
}
</style>
